import React, { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { Icon } from '../../Icon';
import { ErrorMessage } from '../ErrorMessage';

import './styles.scss';

interface Props {
    value: string;
    className?: string;
    disabled?: boolean;
    errors?: string[];
    placeholder?: string;
    removeBorderRadius?: 'top' | 'bottom';
    tabIndex?: number;
    onChange: (value: string) => void;
}

export const PasswordInput = ({
    value,
    className = '',
    disabled,
    errors,
    placeholder,
    removeBorderRadius,
    tabIndex,
    onChange,
}: Props) => {
    const [showPassword, setShowPassword] = useState(false);
    const inputChangeHandler = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value);

    const borderRadiusClassName = useMemo(() => {
        switch (removeBorderRadius) {
            case 'top':
                return 'app-input__input--no-top-border';
            case 'bottom':
                return 'app-input__input--no-bottom-border';
            default:
                return '';
        }
    }, [removeBorderRadius]);

    const passwordVisibilityToggle = useCallback(() => {
        setShowPassword(!showPassword);
    }, [showPassword]);

    return (
        <div className={`app-password-input ${className}`}>
            <input
                type={showPassword ? 'text' : 'password'}
                className={`app-password-input__input ${
                    errors?.length ? 'app-password-input__input--has-error' : ''
                } ${borderRadiusClassName}`}
                value={value}
                placeholder={placeholder}
                disabled={disabled}
                autoComplete='off'
                tabIndex={tabIndex}
                onChange={inputChangeHandler}
            />
            <button className='app-password-input__visibility-toggle-button' onClick={passwordVisibilityToggle}>
                <Icon icon='eye-regular' color='info' />
            </button>
            <ErrorMessage errors={errors} />
        </div>
    );
};
